import API_BASE_FORMATOS_URL from "../../config/config_formatos";

const getBase = () => String(API_BASE_FORMATOS_URL).replace(/\/$/, "");

// ─── IDs configurables ────────────────────────────────────────────────────────
export const DEFAULT_EVENT_ID  = 223;
export const DEFAULT_SPORT_ID  = 4;

export const buildMedalleroEndpoint = (eventId = DEFAULT_EVENT_ID, sportId = DEFAULT_SPORT_ID) =>
  `${getBase()}/api/judo-medal-table/external/${eventId}/local-sport/${sportId}/summary`;

// medallas
export const getMedalColor = (rank) => {
  if (rank === 1) return { bg: "#FFD700", text: "#7a5c00", label: "🥇" };
  if (rank === 2) return { bg: "#C0C0C0", text: "#4a4a4a", label: "🥈" };
  if (rank === 3) return { bg: "#CD7F32", text: "#fff",    label: "🥉" };
  return           { bg: "transparent",   text: "#555",    label: `${rank}°` };
};

export const getTotalMedals = (row) =>
  (row.gold    || 0) +
  (row.silver  || 0) +
  (row.bronze  || 0) +
  (row.fifth   || 0) +
  (row.seventh || 0);

